import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonEN from './locales/en/common.json';
import authEN from './locales/en/auth.json';
import clientEN from './locales/en/client.json';
import staffEN from './locales/en/staff.json';
import inventoryEN from './locales/en/inventory.json';
import bundlerEN from './locales/en/bundler.json';
import clientsEN from './locales/en/clients.json';
import paymentsEN from './locales/en/payments.json';

import commonES from './locales/es/common.json';
import authES from './locales/es/auth.json';
import clientES from './locales/es/client.json';
import staffES from './locales/es/staff.json';
import inventoryES from './locales/es/inventory.json';
import bundlerES from './locales/es/bundler.json';
import clientsES from './locales/es/clients.json';
import paymentsES from './locales/es/payments.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: commonEN,
        auth: authEN,
        client: clientEN,
        staff: staffEN,
        inventory: inventoryEN,
        bundler: bundlerEN,
        clients: clientsEN,
        payments: paymentsEN,
      },
      es: {
        common: commonES,
        auth: authES,
        client: clientES,
        staff: staffES,
        inventory: inventoryES,
        bundler: bundlerES,
        clients: clientsES,
        payments: paymentsES,
      },
    },
    fallbackLng: 'es',
    defaultNS: 'common',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
